<template>
<v-card  flat>
  <v-toolbar height="42" color="#273C51" dark flat>
  <v-card-title class="ma-0 pa-0">
  <span style="font-size:1.4em">Создать новый пост</span>
  </v-card-title>
  <v-spacer></v-spacer>
  <v-icon  @click="close()"> mdi-close</v-icon>
  </v-toolbar>
<v-card-text>

<v-select
@change="changeSelectedGr()"
v-model = 'posts.newPost.accGroupId'
:items="posts.newPost.accGroupsList.slice(1)"
item-text = 'title_ru'
item-value = 'gr_id'
label="Выберите группу аккаунтов">
</v-select>



<v-select
v-model = 'posts.newPost.selectedAcc'
:items="posts.newPost.accountsAll"
label="Выберите аккаунт"  no-data-text="Нет аккаунтов в данной группе">

<template slot="selection" slot-scope="data">
<v-chip :selected="data.selected"      >
<v-avatar> <img :src="data.item.photo_50"></v-avatar>
{{ data.item.title }}
</v-chip>
</template>

<template slot="item" slot-scope="data">
<v-list-tile-avatar> <img :src="data.item.photo_50"> </v-list-tile-avatar>
<v-list-tile-content>
<v-list-tile-title v-html="data.item.title"></v-list-tile-title>
</v-list-tile-content>
<v-spacer></v-spacer>
<v-tooltip top v-if="data.item.info.valid == '0'">
<span>Невалидный аккаунт</span>
<v-btn slot="activator" icon small  ><v-icon color="red">mdi-account-minus</v-icon></v-btn>
</v-tooltip>
<v-tooltip top v-if="data.item.is_closed">
<span>Закрытый аккаунт</span>
<v-btn slot="activator" icon small  ><v-icon color="yellow">mdi-account-alert</v-icon></v-btn>
</v-tooltip>
<v-tooltip top v-if="JSON.parse(data.item.info.limits).friendRequest.expire">
<span>Лимит на заявки в друзья</span>
<v-btn slot="activator" icon small  ><v-icon color="yellow">mdi-account-multiple-plus</v-icon></v-btn>
</v-tooltip>
<v-tooltip top v-if="JSON.parse(data.item.info.limits).messageSend.expire">
<span>Лимит на отправку сообщений</span>
<v-btn slot="activator" icon small  ><v-icon color="yellow">mdi-email</v-icon></v-btn>
</v-tooltip>
<v-tooltip top v-if="data.item.info.my_post">
<span>На данном аккаунте был опубликован пост</span>
<v-btn slot="activator" icon small  ><v-icon color="gray">mdi-comment-multiple-outline</v-icon></v-btn>
</v-tooltip>
<v-tooltip top v-if="data.item.info.my_repost">
<span>На данном аккаунте был опубликован репост</span>
<v-btn slot="activator" icon small  ><v-icon color="gray">mdi-share</v-icon></v-btn>
</v-tooltip>


</template>

</v-select>



<!-- Редактор поста -->
<v-layout style="margin-left:-10px" >
<v-flex md7>
<div style="">
  <v-textarea rows="10" hide-details  solo v-model="posts.newPost.post.text" color="#4A76A8" placeholder="Введите текст поста. Указав тег <tele-link>, будет сгенерирована новая телеграмм ссылка. Например: Вот  тут <tele-link> информация.">
  </v-textarea>
  <div style="margin-top:5px">  <v-text-field hide-details  solo clearable v-model="posts.newPost.post.linkUrl" color="#4A76A8" label="Ссылка на сайт или вложение"></v-text-field> </div>
  <div v-if="posts.newPost.post.make_comment.is" style="margin-top:5px">  <v-text-field hide-details  solo clearable v-model="posts.newPost.post.make_comment.text" color="#4A76A8" label="Ваш комментарий"></v-text-field> </div>
</div>
</v-flex>

<v-flex md5 style=" ">
<v-card  style="margin-left:15px"><v-card-text >
<v-checkbox class="pa-0 ma-0" v-model="posts.newPost.post.pin"  hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Закрепить на стене</span>
</v-checkbox>
<v-checkbox class="pa-0 ma-0" v-model="posts.newPost.post.close_comments"  hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Отключить комментарии</span>
</v-checkbox>
<v-checkbox class="pa-0 ma-0" v-model="posts.newPost.post.add_like"  hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Поставить личный лайк</span>
</v-checkbox>
<v-checkbox class="pa-0 ma-0" v-model="posts.newPost.post.make_comment.is"  hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Добавить комментарий</span>
</v-checkbox>
</v-card-text></v-card>

<v-card  style="margin-left:15px;margin-top:5px"><v-card-text >
<p style="color:#757575;font-size:1.2em"> Теги вставки </p>
<li><strong><code style="cursor:pointer" @click = "posts.newPost.post.text = posts.newPost.post.text + ' <tele-link> '"> &lt;tele-link&gt; </code></strong> - Телеграмм ссылка </li>
</v-card-text></v-card>

</v-flex>

</v-layout>
<!-- Редактор поста закрытие-->




</v-card-text>
<v-card-actions>
<v-spacer/>
<v-btn @click="close()" small color="#273C51" flat style="text-transform:none">Отмена</v-btn>
<v-btn  :loading="loading" :disabled="disabled" @click="createPost()" small color="#273C51" style="text-transform:none" class="white--text">  <v-icon>mdi-plus</v-icon> Создать пост</v-btn>
</v-card-actions>
</v-card>
</template>

<script>

import axios from 'axios'
export default {
props: ['posts'],
data () {
return {
loading: false,
disabled:false,
}
},
methods: {

createPost(){
this.loading = true
this.disabled = true
axios.post('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/posts/new_vk_post.php', {
params:{
params:this.posts.newPost,
}
}).then(response => {
  this.loading = false
  this.disabled = false
if(response.data.post_id){
  this.posts.selectedPost.post_id = response.data.post_id
  this.posts.creator.post_id = response.data.post_id
  this.close()
} else {
  alert('что то пошло не так, обновите страницу и попробуйте еще раз')
}
})
},

changeSelectedGr(){
this.getPostAccounts()
},


getPostAccounts(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/accounts_get.php', {
method: 'GET',
params: {grId:this.posts.newPost.accGroupId},
})
.then( response => {
this.posts.newPost.accountsAll = response.data
})
},
getAccGroups(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/gr_list_get.php', {
method: 'GET',
})
.then( response => {
this.posts.newPost.accGroupsList = response.data
})
},
close(){
  this.posts.modals.newPost = false
},
},
computed:{
},
mounted(){

},
created(){
this.getAccGroups()
this.getPostAccounts()
}

}
</script>

<style    >

</style>
